
define(
	'C3.ShoppingExtensions.NewsletterSignup'
,   [
	//	'C3.ShoppingExtensions.NewsletterSignup.View',
		'C3.ShoppingExtensions.NewsletterSignup.FooterForm',
		'Footer.View',
		'C3.ShoppingExtensions.NewsletterSignup.Model',
		'C3.ShoppingExtensions.NewsletterSignupPage.View',
		'C3.ShoppingExtensions.NewsletterSignup.Automatic.View'
	]
,   function (
	//	NewsletterSignupView,
		NewsletterSignupFooterForm,
		FooterView,
		NewsletterModel,
		NewsletterSignupPageView,
		AutomaticNewsletterPopupView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (application)
		{
			var environment = application.getComponent("Environment");
			var layout = application.getComponent('Layout');
			var pageType = application.getComponent('PageType');


			FooterView.addChildViews &&
                FooterView.addChildViews({
                    CustomNewsLetter: function wrapperFunction() {
                        return function() {
                            return new NewsletterSignupFooterForm({
                                model: new NewsletterModel(),
                                application: application
                            });
                        };
                    }
                });

                var ieRoutes = [
		            'newsletter-signup',
		            'newsletter-signup?:options'
		        ];

				var newsLetterSignupPage = 	{
				        name: 'newsletter-signup',
			            routes: ieRoutes,
			            application: layout.application,
			            view: NewsletterSignupPageView,
			            options: {application :layout.application},
				   }

				pageType.registerPageType(newsLetterSignupPage);


				layout.addToViewEventsDefinition(
				'Footer.View',
				'click [data-action="Automatic.Newsletter.Popup"]',
				function (e) 
				{
					e.stopPropagation();
					e.preventDefault();

					var view = new AutomaticNewsletterPopupView({
						application: layout.application
					});

					if (view)
					layout.showContent(view, {showInModal: true});
				}) 

		}
	};
});
